import axios from './http'

export const solvePlan = (params = {}) => axios.get('/solvePlan/list', params) // 解决方案
export const supportDetail = (params = {}) => axios.get('/supportDetail/list', params) // 服务支持介绍
export const serviceSupport = (params = {}) => axios.get('/serviceSupport/list', params) // 服务支持轮播
export const developCourse = (params = {}) => axios.get('/developCourse/list', params) // 发展历程接口
export const notice = (params = {}) => axios.get('/notice/list', params) // 新闻热点接口
export const noticeDetail = (params = {}) => axios.get('/notice/' + params.id) // 新闻热点接口
export const entQualify = (params = {}) => axios.get('/entQualify/topFive', params) // 网站首页企业资质
export const indexBanner = (params = {}) => axios.get('/indexBanner/list', params) // 网站首页轮播图
export const entSurvey = (params = {}) => axios.get('/entSurvey/list', params) // 企业概况
export const culture = (params = {}) => axios.get('/culture/list', params) // 企业文化
export const middleBanner = (params = {}) => axios.get('/middleBanner/list', params) // 网站首页中间banner数据
export const getParamSet = (params = {}) => axios.get('/paramSet/getParamSet', params) // 网站参数
export const bussinessArea = (params = {}) => axios.get('/bussinessArea/list', params) // 网站首页中间覆盖地区
export const entQualifyList = (params = {}) => axios.get('/entQualify/list', params) // 企业资质
export const propertyRight = (params = {}) => axios.get('/propertyRight/list', params) // 网站首页知识产权
export const indexList = (params = {}) => axios.get('/notice/indexList', params) // 网站首页新闻热点
export const productType = (params = {}) => axios.get('/productType/list', params) // 网站首页企业产品类型
export const product = (params = {}) => axios.get('/product/list', params) // 产品分页接口
export const productBanner = (params = {}) => axios.get('/productType/' + params.id) // 网站首页企业产品类型



// WEBPACK FOOTER //
// ./src/assets/js/apis.js